import './user-details-tabs.scss';
import templateUrl from './user-details-tabs.html';

export default /* @ngInject */ function userDetailsTabs($location, $mdMedia) {
  let tabs = [
    tab('Profile', '/user/profile', 'view_profile', 'accounts_my_profile_profile'),
    //tab('Plans', '/user/manage-plan', 'view_plan', 'accounts_my_profile_plans'),
    //tab('Payments', '/user/payments-profile', 'view_plan', 'accounts_my_profile_payments'),
    tab('Team', '/user/team', 'view_team', 'accounts_my_profile_teams')
  ];

  function tab(title, url, restrictPermission, dataTestId) {
    return {
      title: title,
      url: url,
      restrictPermission: restrictPermission,
      active: false,
      dataTestId: dataTestId
    };
  }

  let findByPath = (path) => {
    angular.forEach(tabs, (_tab)=> {
      _tab.active = (_tab.url === path);
    });
  };

  return {
    templateUrl: templateUrl,
    scope: {},
    replace: true,
    link: (scope) => {
      scope.tabs = tabs;
      scope.screenIsSmall = $mdMedia('xs');
      scope.selectedTabIndex = findByPath($location.path());

      scope.onTabSelected = (_tab) => {
        $location.path(_tab.url);
      };
    }
  };
}



// WEBPACK FOOTER //
// ./user/directives/user-details-tabs.js